import { immer } from "zustand/middleware/immer";
import { AuthStore, State } from "./types";
import { PersistStorageKeys } from "../models";
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

const initialState: State = {
  name: null,
  user_id: null,
};

export const useAuthStore = create<AuthStore>()(
  persist(
    immer((set) => ({
      ...initialState,
      setUserName: (name: string | null) =>
        set((state) => {
          state.name = name;
        }),
      setUserId: (user_id: string | null) =>
        set((state) => {
          state.user_id = user_id;
        }),

      logout: () =>
        set((state) => {
          state.name = null;
          state.user_id = null;
        }),
    })),
    {
      name: PersistStorageKeys.AUTH,
      storage: createJSONStorage(() => localStorage),
    }
  )
);
